<template>
  <div
    class="prose prose-neutral flex flex-col bg-light-0 dark:prose-invert dark:bg-dark-0 md:flex-row"
  >
    <div
      class="fixed z-40 w-full basis-20 bg-light-1 shadow dark:bg-dark-1 dark:text-white md:relative md:w-auto md:basis-12"
    >
      <SideNavBar />
    </div>

    <div
      v-if="isInDeepLinkMode"
      class="fixed top-0 left-0 right-0 z-30 flex items-center justify-center gap-2 bg-amber-100 px-3 py-1 text-xs font-medium text-amber-900 shadow dark:bg-amber-800 dark:text-amber-100"
    >
      <em
        class="mdi"
        :class="isEditMode ? 'mdi-pencil-outline' : 'mdi-eye-outline'"
      ></em>
      <span>{{
        isEditMode ? 'Bearbeitungsmodus aktiv.' : 'Ansichtsmodus aktiv.'
      }}</span>
    </div>

    <div
      v-if="isListWorkMode"
      class="fixed z-50 w-full bg-amber-500 text-center dark:bg-amber-700"
    >
      Dieser Modus ist nur für den internen Gebrauch bestimmt. Bitte seien Sie
      vorsichtig beim Speichern von Daten!
    </div>

    <div
      v-if="isInSandboxMode"
      class="fixed z-50 w-full bg-primary-2 text-center text-sm p-1"
    >
      You are now in SANDBOX MODE. You can exit it from your profile icon by
      selecting "Exit Training"
    </div>

    <div
      v-scroll-restoration="'layout-wrapper'"
      class="h-screen overflow-y-auto bg-light-0 dark:bg-dark-0 md:grow md:basis-0"
    >
      <slot />
    </div>

    <div
      v-if="currentRoute === routesNames.DETAIL_VIEW"
      :class="[isSideBarOpen ? 'w-1/3' : 'w-0']"
      class="fixed bottom-0 z-20 flex h-1/2 justify-center rounded-3xl shadow align-middle transition-all dark:border-dark-2 md:relative md:bottom-0 md:right-0 md:mt-0 md:rounded-none"
    >
      <div
        class="side-menu-button border-y border-l border-gray-300 bg-light-1 dark:border-dark-2 dark:bg-dark-1"
        data-testid="sideMenuButtonToggle"
        @click="toggleSideMenu"
      >
        <em
          class="mdi mdi-menu-open text-2xl"
          :class="[isSideBarOpen ? 'flip-horizontally' : '']"
        ></em>
      </div>
      <div
        data-testid="sideBar"
        :class="[isSideBarOpen ? 'md:w-full' : 'hide-side-bar']"
      >
        <slot name="side" />
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import SideNavBar from '@/components/SideMenu/SideNavBar.vue';
import { useRouter } from 'vue-router';
import { routesNames } from '@/router';
import { computed } from 'vue';
import { useLayoutStore, WorkMode } from '@/store/layout/layoutStore';
import { useOrderStore } from '@/store/order/orderStore';

const currentRoute = computed(() => {
  return useRouter().currentRoute.value.name;
});

const isListWorkMode = computed(() => {
  return useLayoutStore().workMode === WorkMode.LIST;
});

const isInSandboxMode = computed(() => {
  return useLayoutStore().workMode === WorkMode.SANDBOX;
});

const isInDeepLinkMode = computed(() => {
  return useLayoutStore().workMode === WorkMode.DEEP_LINK;
});

const isEditMode = computed(() => {
  return isInDeepLinkMode.value && useOrderStore().activeOrder?.isEditable;
});

const isSideBarOpen = computed(() => {
  return useLayoutStore().isSideMenuOpen;
});

const toggleSideMenu = () => {
  useLayoutStore().toggleSideMenu();
};
</script>
<style scoped>
.side-menu-button {
  position: absolute;
  top: 140px;
  left: -65px;
  padding: 20px;
  border-radius: 10px 0 0 10px;
}

.flip-horizontally::before {
  transform: rotate(180deg);
}

.hide-side-bar {
  width: 0;
  overflow: hidden;
}
</style>
